module.exports = __webpack_public_path__ + "static/img/1.fad6f4a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/zh/1.png
// module id = WIue
// module chunks = 0